// import React, { useEffect, useState } from "react";
// import Input from "../../lib/ui/Input/Input";
// import ListItem from "../../component/ListItem";
// import { useParams, useNavigate } from "react-router-dom";
// import Tabs from "../../component/Tabs";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchMenuData, setSelectedCategory, clearCart, logoutSuccess } from "../../redux/action";
// import CartButton from "../../component/CartButton";
// import LoginPage from "../Login";
// import DietFilter from "../../component/DietFilter/DietFilter";
// import { guestLogin } from "../../redux/action";
// import './menu.scss';
// import CategoryPopup from "../../component/CategoryPopup/CategoryPopup";
// import { SlidersHorizontal } from "lucide-react";
// import Posters from "../../component/PosterSlider/Posters";
// import ActiveRestaurantModal from "../../component/ActiveRestaurantModal/ActiveRestaurantModal";
// import { toast } from "react-toastify";

// const MenuPage = () => {
//   const { restaurant, id, table } = useParams();
//   const [selectedTabId, setSelectedTab] = useState(null);
//   const [selectedDietId, setSelectedDiet] = useState(0);
//   const [search, setSearch] = useState("");
//   const [showFilter, setShowFilter] = useState(true);
//   const [openPopup, setOpenPopup] = useState(false);
//   const [showCrossRestaurantModal, setShowCrossRestaurantModal] = useState(false);
//   const [activeSessionDetails, setActiveSessionDetails] = useState(null);

//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const menuList = useSelector((state) => state?.user.menu);
//   const user = useSelector((state) => state?.user.user);
//   const isGuest = useSelector((state) => state?.user.isGuest);
//   const selectedCategory = useSelector((state) => state?.user.selectedCategory);

//   // 1. Fetch Menu for the active URL restaurant ID
//   useEffect(() => {
//     if (id) {
//       dispatch(fetchMenuData(id));
//     }
//     if (selectedCategory) {
//       setSelectedTab(selectedCategory);
//     }
//     dispatch({ type: "CLEAR_REDIRECT" });
//   }, [id, selectedCategory, dispatch]);

//   // 2. Cross-Restaurant & Table Transition Guard
//  // 2. Cross-Restaurant & Table Transition Guard
// useEffect(() => {
//   const rawUserInfo = localStorage.getItem('userInfo');
//   const rawAllInfo = localStorage.getItem('allInfo');

//   if (!rawUserInfo) return;

//   try {
//     const parsedUserInfo = JSON.parse(rawUserInfo);
//     let parsedAllInfo = null;
//     try {
//       parsedAllInfo = rawAllInfo ? JSON.parse(rawAllInfo) : null;
//     } catch (err) {
//       console.error("Error parsing allInfo:", err);
//     }

//     const storedRestId = parsedUserInfo?.restaurantId;
//     const currentUrlRestId = id;
//     const storedTable = parsedUserInfo?.tableNumber;

//     // Has the customer ordered food & is the session active?
//     const hasActiveUnpaidOrder = Boolean(
//       parsedAllInfo &&
//       parsedAllInfo.tableOtp &&
//       parsedAllInfo.isActive !== false
//     );

//     // ── CHECK 1: Scanned a DIFFERENT Restaurant ──
//     if (currentUrlRestId && storedRestId && storedRestId.toLowerCase() !== currentUrlRestId.toLowerCase()) {
//       if (hasActiveUnpaidOrder) {
//         setActiveSessionDetails({
//           restaurantName: localStorage.getItem("restaurant"),
//           restaurantId: storedRestId,
//           tableNumber: storedTable || parsedAllInfo?.tableNumber
//         });
//         setShowCrossRestaurantModal(true);
//         return;
//       } else {
//         console.log(`Switching tenant from ${storedRestId} to ${currentUrlRestId}`);
//         parsedUserInfo.restaurantId = currentUrlRestId;
//         parsedUserInfo.tableNumber = Number(table) || table;
//         localStorage.setItem('userInfo', JSON.stringify(parsedUserInfo));
//         localStorage.setItem('restaurant', restaurant);
//         localStorage.setItem('restaurantId', currentUrlRestId);
//         localStorage.setItem('table', table);

//         localStorage.removeItem('allInfo');
//         dispatch(clearCart());
//       }
//     }

//     // ── CHECK 2: Same Restaurant, but switched TABLE ──
//     if (table && String(storedTable) !== String(table)) {
//       if (!hasActiveUnpaidOrder) {
//         console.log(`Switching table from ${storedTable} to ${table}`);
//         parsedUserInfo.tableNumber = Number(table) || table;
//         localStorage.setItem('userInfo', JSON.stringify(parsedUserInfo));
//         localStorage.setItem('table', table);
//         dispatch(clearCart());
//       } else {
//         // 🔒 Added toastId to prevent multiple duplicates
//         toast.warn(`Unable to switch table to ${table} because your session is active.`, {
//           toastId: `active-table-warn-${table}`
//         });
//       }
//     }
//   } catch (e) {
//     console.error("Error verifying restaurant/table boundaries:", e);
//   }
// }, [id, table, restaurant, dispatch]);

//   const handleReturnToActiveRestaurant = () => {
//     if (!activeSessionDetails) return;
//     const oldRest = localStorage.getItem("restaurant") || "active";
//     const oldRestId = activeSessionDetails.restaurantId;
//     const oldTable = activeSessionDetails.tableNumber;
//     navigate(`/${oldRest}/${oldRestId}/${oldTable}/pay-bill`);
//   };

//   const handleForceLogout = () => {
//     const allowedKeys = [
//       "customer_portal_theme",
//       "showBannerInLoginPage",
//       "customer_portal_branch_id",
//       "packageType"
//     ];

//     Object.keys(sessionStorage).forEach((key) => {
//       if (!allowedKeys.includes(key)) sessionStorage.removeItem(key);
//     });

//     Object.keys(localStorage).forEach((key) => {
//       if (!allowedKeys.includes(key)) localStorage.removeItem(key);
//     });

//     dispatch(logoutSuccess());
//     setShowCrossRestaurantModal(false);
//     navigate(`/${restaurant}/${id}/${table}`);
//   };

//   const tabList = () => {
//     if (!menuList?.categories) return [];
//     return menuList?.categories.map((val) => ({
//       categoryId: val.categoryId,
//       categoryName: val.categoryName,
//       isSelected: val.isSelected,
//     }));
//   };

//   const selectedItems = () => {
//     if (!menuList || !menuList?.categories) return null;

//     const category = menuList?.categories.find(
//       (cat) => cat.categoryId === selectedTabId
//     ) || menuList?.categories[0];

//     if (category) {
//       let filtered = (category.items || []).filter((food) =>
//         food?.foodName?.toLowerCase().includes(search.toLowerCase())
//       );

//       if (selectedDietId !== 0) {
//         filtered = filtered.filter((food) => food?.foodTypeId === selectedDietId);
//       }

//       return { ...category, items: filtered };
//     }
//     return null;
//   };

//   return (
//     <div className="menuPageContainer">
//       <div className="pageContent">
//         <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
//           <div style={styles.searchBox}>
//             <svg style={styles.searchIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
//               <path d="M21 20l-5.6-5.6a7 7 0 1 0-1.4 1.4L20 21zM10 16a6 6 0 1 1 0-12 6 6 0 0 1 0 12z" />
//             </svg>
//             <input
//               type="text"
//               placeholder="Search for food..."
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               style={styles.input}
//             />
//             <div style={styles.divider} />
//             <span className="diet-filter-icon" onClick={() => setShowFilter((prev) => !prev)}>
//               <SlidersHorizontal size={15} stroke="var(--seat-chip-color)" />
//             </span>
//           </div>
//         </div>

//         {showFilter && <DietFilter dietSelect={setSelectedDiet} />}

//         <Posters />

//         {menuList && (
//           <>
//             <Tabs
//               tabs={tabList()}
//               tabSelect={(catId) => {
//                 setSelectedTab(catId);
//                 dispatch(setSelectedCategory(catId));
//               }}
//               selectedTabId={selectedTabId}
//             />
//             <ListItem category={selectedItems()} showNote={false} />
//           </>
//         )}

//         {isGuest !== true && <CartButton />}

//         {isGuest !== false && (
//           <button className="menuButton" onClick={() => setOpenPopup(true)}>
//             🍴 Menu
//           </button>
//         )}

//         <CategoryPopup open={openPopup} onClose={() => setOpenPopup(false)} />

//         {/* 🛑 Cross-Restaurant Active Order Blocker */}
//         <ActiveRestaurantModal
//           isOpen={showCrossRestaurantModal}
//           activeSession={activeSessionDetails}
//           onGoToActive={handleReturnToActiveRestaurant}
//           onLogout={handleForceLogout}
//         />
//       </div>
//     </div>
//   );
// };

// const styles = {
//   searchBox: {
//     position: "relative",
//     maxWidth: "500px",
//     margin: "8px auto",
//     background: "#ffffff",
//     borderRadius: "12px",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//     padding: "10px 10px",
//     display: "flex",
//     alignItems: "center",
//   },
//   divider: {
//     width: 1,
//     height: 24,
//     backgroundColor: "#939090ff",
//     margin: "0 8px",
//   },
//   searchIcon: {
//     position: "absolute",
//     left: "18px",
//     width: "22px",
//     height: "22px",
//     fill: "#FB6236",
//   },
//   input: {
//     padding: "0px 0px 0px 45px",
//     width: "100%",
//     fontSize: "16px",
//     border: "none",
//     outline: "none",
//     background: "transparent",
//     color: "#484646",
//     WebkitAppearance: "none",
//   },
// };

// export default MenuPage;

import React, { useEffect, useState } from "react";
import ListItem from "../../component/ListItem";
import { useParams, useNavigate } from "react-router-dom";
import Tabs from "../../component/Tabs";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMenuData,
  setSelectedCategory,
  clearCart,
  logoutSuccess,
  guestLogin,
} from "../../redux/action";
import CartButton from "../../component/CartButton";
import DietFilter from "../../component/DietFilter/DietFilter";
import "./menu.scss";
import CategoryPopup from "../../component/CategoryPopup/CategoryPopup";
import { SlidersHorizontal } from "lucide-react";
import Posters from "../../component/PosterSlider/Posters";
import ActiveRestaurantModal from "../../component/ActiveRestaurantModal/ActiveRestaurantModal";
import { toast } from "react-toastify";

const MenuPage = ({ experience }) => {
  const { restaurant, id, table } = useParams();
  const [selectedTabId, setSelectedTab] = useState(null);
  const [selectedDietIds, setSelectedDiet] = useState([]);
  const [search, setSearch] = useState("");
  const [showFilter, setShowFilter] = useState(true);
  const [openPopup, setOpenPopup] = useState(false);
  const [showCrossRestaurantModal, setShowCrossRestaurantModal] =
    useState(false);
  const [activeSessionDetails, setActiveSessionDetails] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const menuList = useSelector((state) => state?.user?.menu);
  const reduxisGuest = useSelector((state) => state?.user?.guestUser);
  //const isGuest = reduxisGuest === true || localStorage.getItem("guestUser") === "true";
  const selectedCategory = useSelector(
    (state) => state?.user?.selectedCategory,
  );
  const packageType = sessionStorage.getItem("packageType");
  const isGuest = packageType === "catelog" || table === "cat";
  const isTakeaway = experience === "takeaway" || table === "takeaway";

  useEffect(() => {
    const nextExperience = isTakeaway ? `takeaway:${id}` : `table:${id}:${table}`;
    const previousExperience = sessionStorage.getItem("menu_cart_experience");
    if (previousExperience && previousExperience !== nextExperience) dispatch(clearCart());
    sessionStorage.setItem("menu_cart_experience", nextExperience);
  }, [dispatch, id, isTakeaway, table]);

  // 1. Fetch Menu for the active URL restaurant ID & reset category state
  useEffect(() => {
    if (id) {
      setSelectedTab(null); // Clear selected tab for fresh restaurant
      dispatch(setSelectedCategory(null)); // Clear old restaurant category in Redux
      dispatch(fetchMenuData(id));
    }
    dispatch({ type: "CLEAR_REDIRECT" });
  }, [id, dispatch]);

  //Sync category selection from Redux (e.g. from CategoryPopup click)
  useEffect(() => {
    if (selectedCategory) {
      setSelectedTab(selectedCategory);
    }
  }, [selectedCategory]);

  // 2. Set default active category once menuList loads
  useEffect(() => {
    if (menuList?.categories?.length > 0 && !selectedTabId) {
      setSelectedTab(menuList.categories[0].categoryId);
    }
  }, [menuList, selectedTabId]);

  // 3. Cross-Restaurant & Table Transition Guard
  useEffect(() => {
    if (isTakeaway) return;
    const rawUserInfo = localStorage.getItem("userInfo");
    const rawAllInfo = localStorage.getItem("allInfo");

    if (!rawUserInfo) return;

    try {
      const parsedUserInfo = JSON.parse(rawUserInfo);
      let parsedAllInfo = null;
      try {
        parsedAllInfo = rawAllInfo ? JSON.parse(rawAllInfo) : null;
      } catch (err) {
        console.error("Error parsing allInfo:", err);
      }

      const storedRestId = parsedUserInfo?.restaurantId;
      const currentUrlRestId = id;
      const storedTable = parsedUserInfo?.tableNumber;

      // Has the customer ordered food & is the session active?
      const hasActiveUnpaidOrder = Boolean(
        parsedAllInfo &&
        parsedAllInfo.tableOtp &&
        parsedAllInfo.isActive !== false,
      );

      // ── CHECK 1: Scanned a DIFFERENT Restaurant ──
      if (
        currentUrlRestId &&
        storedRestId &&
        storedRestId.toLowerCase() !== currentUrlRestId.toLowerCase()
      ) {
        if (hasActiveUnpaidOrder) {
          setActiveSessionDetails({
            restaurantName:
              localStorage.getItem("restaurant") || "Current Restaurant",
            restaurantId: storedRestId,
            tableNumber: storedTable || parsedAllInfo?.tableNumber,
          });
          setShowCrossRestaurantModal(true);
          return;
        } else {
          console.log(
            `Switching tenant from ${storedRestId} to ${currentUrlRestId}`,
          );
          parsedUserInfo.restaurantId = currentUrlRestId;
          parsedUserInfo.tableNumber = Number(table) || table;
          localStorage.setItem("userInfo", JSON.stringify(parsedUserInfo));
          localStorage.setItem("restaurant", restaurant);
          localStorage.setItem("restaurantId", currentUrlRestId);
          localStorage.setItem("table", table);
          localStorage.removeItem("allInfo");
          dispatch(clearCart());
        }

        if (storedTable === "cat") {
          //localStorage.removeItem("guestUser");
          // dispatch(guestLogin(false));
          handleForceLogout();
        }
      }

      // ── CHECK 2: Same Restaurant, but switched TABLE ──
      if (table && String(storedTable) !== String(table)) {
        if (!hasActiveUnpaidOrder) {
          console.log(`Switching table from ${storedTable} to ${table}`);
          parsedUserInfo.tableNumber = Number(table) || table;
          localStorage.setItem("userInfo", JSON.stringify(parsedUserInfo));
          localStorage.setItem("table", table);
          dispatch(clearCart());
        } else {
          toast.warn(
            `Unable to switch table to ${table} because your session is active.`,
            {
              toastId: `active-table-warn-${table}`,
            },
          );
        }
      }
    } catch (e) {
      console.error("Error verifying restaurant/table boundaries:", e);
    }
  }, [id, table, restaurant, dispatch, isTakeaway]);

  const handleReturnToActiveRestaurant = () => {
    if (!activeSessionDetails) return;
    const oldRest = localStorage.getItem("restaurant") || "active";
    const oldRestId = activeSessionDetails.restaurantId;
    const oldTable = activeSessionDetails.tableNumber;
    navigate(`/${oldRest}/${oldRestId}/${oldTable}/pay-bill`);
  };

  const handleForceLogout = () => {
    const allowedKeys = [
      "customer_portal_theme",
      "showBannerInLoginPage",
      "customer_portal_branch_id",
      "packageType",
      "guestUser",
      "table",
    ];

    Object.keys(sessionStorage).forEach((key) => {
      if (!allowedKeys.includes(key)) sessionStorage.removeItem(key);
    });

    Object.keys(localStorage).forEach((key) => {
      if (!allowedKeys.includes(key)) localStorage.removeItem(key);
    });

    dispatch(logoutSuccess());
    setShowCrossRestaurantModal(false);
    navigate(`/${restaurant}/${id}/${table}`);
  };

  const tabList = () => {
    if (!menuList?.categories) return [];
    return menuList.categories.map((val) => ({
      categoryId: val.categoryId,
      categoryName: val.categoryName,
      isSelected: val.isSelected,
    }));
  };

  const selectedItems = () => {
    if (!menuList?.categories || menuList.categories.length === 0) return null;

    const category =
      menuList.categories.find((cat) => cat.categoryId === selectedTabId) ||
      menuList.categories[0];

    if (category) {
      let filtered = (category.items || []).filter((food) =>
        food?.foodName?.toLowerCase().includes(search.toLowerCase()),
      );

      if (selectedDietIds.length > 0 && selectedDietIds.length < 4) {
        filtered = filtered.filter(
          (food) => selectedDietIds.includes(food?.foodTypeId),
        );
      }

      return { ...category, items: filtered };
    }
    return null;
  };

  return (
    <div className={`menuPageContainer${isTakeaway ? " takeaway-menu-content" : ""}`}>
      <div className="pageContent">
        <div className="menu-search-row" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div className="menu-search-box" style={styles.searchBox}>
            <svg
              style={styles.searchIcon}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="M21 20l-5.6-5.6a7 7 0 1 0-1.4 1.4L20 21zM10 16a6 6 0 1 1 0-12 6 6 0 0 1 0 12z" />
            </svg>
            <input
              type="text"
              placeholder="Search for food..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={styles.input}
            />
            <div style={styles.divider} />
            <span
              className="diet-filter-icon"
              onClick={() => setShowFilter((prev) => !prev)}
            >
              <SlidersHorizontal size={15} stroke="var(--seat-chip-color)" />
            </span>
          </div>
        </div>

        {showFilter && <DietFilter dietSelect={setSelectedDiet} />}

        <Posters />

        {menuList && (
          <>
            <Tabs
              tabs={tabList()}
              tabSelect={(catId) => {
                setSelectedTab(catId);
                dispatch(setSelectedCategory(catId));
              }}
              selectedTabId={selectedTabId}
            />
            <ListItem category={selectedItems()} showNote={false} extraMargin={!isGuest} />
          </>
        )}

        {!isGuest && <CartButton experience={isTakeaway ? "takeaway" : "table"} />}

        {isGuest !== false && (
          <button className="menuButton" onClick={() => setOpenPopup(true)}>
            🍴 Menu
          </button>
        )}

        <CategoryPopup open={openPopup} onClose={() => setOpenPopup(false)} />

        {/* 🛑 Cross-Restaurant Active Order Blocker */}
        <ActiveRestaurantModal
          isOpen={showCrossRestaurantModal}
          activeSession={activeSessionDetails}
          onGoToActive={handleReturnToActiveRestaurant}
          onLogout={handleForceLogout}
        />
      </div>
    </div>
  );
};

const styles = {
  searchBox: {
    position: "relative",
    maxWidth: "500px",
    margin: "8px auto",
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    padding: "10px 10px",
    display: "flex",
    alignItems: "center",
  },
  divider: {
    width: 1,
    height: 24,
    backgroundColor: "#939090ff",
    margin: "0 8px",
  },
  searchIcon: {
    position: "absolute",
    left: "18px",
    width: "22px",
    height: "22px",
    fill: "#FB6236",
  },
  input: {
    padding: "0px 0px 0px 45px",
    width: "100%",
    fontSize: "16px",
    border: "none",
    outline: "none",
    background: "transparent",
    color: "#484646",
    WebkitAppearance: "none",
  },
};

export default MenuPage;
